import _ from 'underscore';
import React, { useCallback, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';

import { composePath } from '@culture/common-helpers/params';
import CommonPropTypes from 'utils/propTypes/common';
import {
	catalogsActions,
	catalogsOperations,
	catalogsSelectors
} from 'ducks/catalogs';

import Catalog from '../components/Catalog';

const {
	publicRuntimeConfig: {
		entities: { child100Rubric }
	}
} = getConfig();

const CatalogContainer = ({
	total,
	limit,
	urlParams,
	movies,
	rubric,
	rubricPath
}) => {
	const dispatch = useDispatch();
	const filters = useSelector(catalogsSelectors.selectFilterValues);
	const { push, asPath, pathname } = useRouter();

	useEffect(() => {
		const params = {
			...urlParams,
			rubricPath,
			additionalRubrics: [child100Rubric]
		};

		if (rubricPath.match('child-100')) {
			params.additionalFilters = ['schoolClasses', 'thematics'];
		}

		dispatch(
			catalogsOperations.getFilterValues('catalogFilters/cinema/movies', params)
		);
	}, [asPath]);

	useEffect(() => () => dispatch(catalogsActions.resetFilterValues()), []);

	const handleFilterChange = useCallback(
		(name, value) => {
			const currentValue = urlParams[name] || '';
			const path = name === 'rubric' ? value : rubricPath;

			if (value !== currentValue || path !== rubricPath) {
				let params = {
					...urlParams,
					page: null
				};

				if (name !== 'rubric') {
					params[`${name}`] = value;
				}

				if (!path.match('child-100')) {
					params = _(params).omit('schoolClass', 'genre');
				}

				push(composePath(`/${path}`, params));
			}
		},
		[urlParams]
	);

	const handleFilterReset = useCallback(() => {
		push({ pathname, query: _(urlParams).pick('sort') });
	}, [urlParams]);

	const filterItems = useMemo(
		() =>
			// const schoolClasses = _(filters.schoolClasses).map(
			// 	({ schoolClass, title }) => ({
			// 		schoolClass,
			// 		title: +schoolClass ? `${title} класс` : title
			// 	})
			// );

			[
				{
					title: 'Актер',
					values: filters.actors || [],
					key: 'actor',
					icon: 'catalogActor',
					type: 'select'
				},
				{
					title: 'Год',
					values: filters.years || [],
					key: 'year',
					icon: 'catalogDate',
					type: 'select'
				},
				{
					title: 'Режиссер',
					values: filters.directors || [],
					key: 'director',
					icon: 'catalogDirector',
					type: 'select'
				},
				{
					title: 'Рубрики',
					values: filters.rubrics || [],
					key: 'rubric',
					icon: 'dots',
					type: 'select',
					valueField: 'path',
					resetOption: {
						title: 'Показать все',
						path: 'cinema/movies'
					}
				},
				// {
				// 	title: 'Класс',
				// 	values: schoolClasses,
				// 	key: 'schoolClass',
				// 	icon: 'catalogSchoolClass',
				// 	type: 'select',
				// 	valueField: 'schoolClass',
				// 	searchable: false,
				// 	resetOption: {
				// 		title: 'Показать все',
				// 		schoolClass: ''
				// 	}
				// },
				{
					title: 'Тематики',
					values: filters.thematics || [],
					key: 'genre',
					icon: 'catalogGenre',
					type: 'select'
				},
				{
					title: 'С тифлокомментариями',
					isShow: filters.tifloComments,
					key: 'withTifloComments',
					icon: urlParams.withTifloComments
						? 'catalogToggleActive'
						: 'catalogToggle',
					type: 'button',
					value: !urlParams.withTifloComments || null,
					active: !!urlParams.withTifloComments
				}
			],
		[filters, urlParams]
	);

	const params = { ...urlParams };

	if (rubricPath !== 'cinema/movies') {
		params.rubric = rubricPath;
	}

	return (
		<Catalog
			onFilterChange={handleFilterChange}
			onFilterReset={handleFilterReset}
			filters={filterItems}
			filtersLoaded={!_.isEmpty(filters)}
			total={total}
			limit={limit}
			urlParams={params}
			movies={movies}
			title={rubric.headingTitle}
		/>
	);
};

CatalogContainer.propTypes = {
	total: PropTypes.number.isRequired,
	movies: PropTypes.array.isRequired,
	limit: PropTypes.number.isRequired,
	urlParams: PropTypes.object.isRequired,
	rubric: CommonPropTypes.rubric,
	rubricPath: PropTypes.string.isRequired
};

CatalogContainer.defaultProps = {
	rubric: {}
};

export default CatalogContainer;
